import { render, staticRenderFns } from "./TeamsItem.vue?vue&type=template&id=f4d69872"
import script from "./TeamsItem.vue?vue&type=script&lang=js"
export * from "./TeamsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4d69872')) {
      api.createRecord('f4d69872', component.options)
    } else {
      api.reload('f4d69872', component.options)
    }
    module.hot.accept("./TeamsItem.vue?vue&type=template&id=f4d69872", function () {
      api.rerender('f4d69872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/TeamsItem.vue"
export default component.exports